import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

const ModalExpiracionSesion = ({ open, handleClose, titulo, texto }) => {

  return (
    <>
      <Dialog
        open={open}
        onClose={() => handleClose(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{ '& .MuiDialog-paper': { width: '25rem', maxWidth: '25rem' } }}
      >
        <DialogTitle>{titulo}</DialogTitle>
        <DialogContent>
          <DialogContentText
          >{texto}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose(false)} color="success" variant="contained">
            Continuar
          </Button>
          <Button onClick={() => handleClose(true)} color="error" variant="contained">
            Cerrar Sesión
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default ModalExpiracionSesion